import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
`;

export const Header = styled.header`
  padding: 20px 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #e7e8ec;

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 0;
  background-color: #ffffff;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  align-items: center;
  display: flex;
  flex: 1;
  min-height: 0;
  justify-content: center;
  padding: 24px 0 24px 24px;
  overflow-y: auto;

  @media (max-width: 768px) {
    min-height: 100vh;
    padding: 20px;
    width: 100%;
  }
`;
